import { render } from "./FrenteCaixaModal.vue?vue&type=template&id=495b1f18&scoped=true&ts=true"
import script from "./FrenteCaixaModal.vue?vue&type=script&lang=ts"
export * from "./FrenteCaixaModal.vue?vue&type=script&lang=ts"

import "./FrenteCaixaModal.vue?vue&type=style&index=0&id=495b1f18&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495b1f18"]])

export default __exports__